import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const PaymentCancel = () => {
  const { lang } = useLang();
  const t = (de, en) => (lang === "de" ? de : en);
  return (
    <div className="min-h-screen flex items-center justify-center px-4 pt-28 pb-32" data-testid="payment-cancel-page">
      <div className="max-w-lg w-full text-center">
        <XCircle size={44} className="text-[#ff0033] mx-auto" />
        <h1 className="font-heading text-4xl uppercase text-white tracking-tight mt-5">{t("Zahlung abgebrochen", "Payment cancelled")}</h1>
        <p className="text-neutral-400 mt-4">{t("Deine Buchung wurde nicht abgeschlossen und der Platz wieder freigegeben. Du kannst es jederzeit erneut versuchen.", "Your booking was not completed and the spot has been released. You can try again anytime.")}</p>
        <div className="flex items-center justify-center gap-3 mt-8">
          <Link to="/kurse" className="inline-block bg-[#ff0033] text-white font-heading uppercase tracking-wider px-8 py-3 hover:bg-[#cc0029] transition-colors" data-testid="cancel-back-btn">{t("Zurück zu den Kursen", "Back to courses")}</Link>
          <Link to="/" className="inline-block border border-white/20 text-white font-heading uppercase tracking-wider px-8 py-3 hover:border-[#ff0033] hover:text-[#ff0033] transition-colors">{t("Startseite", "Home")}</Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
